import { Button, LuIcon, Text } from "@overmap-ai/blocks"
import { selectIssueTypeById } from "@overmap-ai/core"
import { getRouteApi, Link } from "@tanstack/react-router"
import { memo } from "react"

import { IssueTypeIcon } from "../../components/Icons/IssueTypeIcon"
import { modelIconMapping } from "../../mappings/icons"
import { useAppSelector } from "../../store"
import { BaseTopBar } from "../TopBars/BaseTopBar"

const routeApi = getRouteApi("/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/general")

export const IssueTypeSettingsGeneralViewTopBar = memo(() => {
	const { issueTypeId } = routeApi.useParams()
	const issueType = useAppSelector(selectIssueTypeById(issueTypeId))!

	return (
		<BaseTopBar
			showAIButton={false}
			leftContent={
				<Link
					from="/$organizationId/settings/issue-types/$issueTypeId/general"
					to="/$organizationId/settings/issue-types/$issueTypeId"
				>
					<Button>
						<LuIcon icon={modelIconMapping.arrowLeft} />
						<IssueTypeIcon issueTypeId={issueTypeId} />
						<Text>{issueType.name}</Text>
					</Button>
				</Link>
			}
		/>
	)
})
IssueTypeSettingsGeneralViewTopBar.displayName = "IssueTypeSettingsGeneralViewTopBar"
